module.exports = __webpack_public_path__ + "static/biker-4ffeb63a1a1bdfaf465dd352707011d8.jpg";